import { Trans } from 'next-i18next';
import { TermsLink, TermsLinkProps } from './Links/TermsLink';
import { PrivacyPolicyLink } from './Links/PrivacyPolicyLink';
import { FC } from 'react';

export const TermsOfAgreementText: FC<{
  type: TermsLinkProps['type'];
  isOresundPay?: boolean;
}> = ({ type, isOresundPay }) => (
  <Trans i18nKey="termsOfAgreement" ns="common">
    <TermsLink type={type} isOresundPay={isOresundPay} />
    <PrivacyPolicyLink type={type} />
  </Trans>
);
